import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./LatestAddedProduct.module.css";
import imageWhite from "../../assets/images/dashboard/latest-added-products-white.svg";
import moment from "moment"; 
import { TableOptions } from "../../utils/messageConstants";
import { Link } from "react-router-dom";
import { Permissions, checkIfPermitted } from "../../services/RolePermissionService";

let order = "desc";
function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}
export class LatestAddedProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleBtnClick = () => {
    if (order === "desc") {
      this.refs.table.handleSort("asc", "name");
      order = "asc";
    } else {
      this.refs.table.handleSort("desc", "name");
      order = "desc";
    }
  };

  render() {
    const dashboardData = this.props.dashboardCounts;
    return (
      <div>
        <div className={`card ${style.latestAddedProductCard}`}>
          <Link to={checkIfPermitted(Permissions.VIEW_INVENTORY) 
          ? "/app/inventorylist" : "/app/dashboard"}>
            <div className={`card-header ${style.latestAddedProductHeader}`}>
              <div className="d-flex align-items-center dashboard-list-box">
                <img src={imageWhite} alt="Latest Added Product" />
              Latest Added Product
              </div>
              <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
            </div>
          <div className="card-body dashboard-time-table-wrapper">
            <BootstrapTable ref="table" data={dashboardData.productList} options={TableOptions} version="4">
              <TableHeaderColumn
                dataField="product_name"
                isKey={true}
                // dataSort={true}
                width={"55%"}
              >
                Product Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="loading_date"
                dataFormat={dateFormatter}
                // dataSort={true}
                width={"45%"}
              >
                Loading Date
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          </Link>
        </div>
      </div>
    );
  }
}


export default LatestAddedProduct;

